/**
 * Legal/Index Controller
 *
 * Displays a legal agreement that needs to be accepted
 */

// the constructor for this object
function LegalViewController() { }

// the object
LegalViewController.prototype = {
    constructor: LegalViewController,
    
    // the legal agreement id
    legalAgreementId: false,
    
    // initialize the controller
    init: function() 
    {    
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        PortalHelper.debugMessage('Legal View Initialized');
    },
    
    // run the controller
    run: function()
    {    
        // get and populate the orders
        this._getLegalAgreement();
        
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Legal View Controller Ran');
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        // set the base order id
        if (segments.length == 1) {
            this.legalAgreementId = segments[0];
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   

    },
    
    // get the orders from the api
    _getLegalAgreement: function()
    {
        // make the request
        var agreementsRequest = new PortalRequest;
        agreementsRequest.makeRequest(
            '/legal/get-agreement',
            {
                legalAgreementId: PortalMain.LegalViewController.legalAgreementId
            },
            function(agreement) {
                
                // show product specific elements
                PortalMain.LegalViewController._populateAgreement(agreement);
                    
                // set the headline
                PortalMain.LegalViewController._setHeadline(agreement);
                    
                // set the breadcrumbs
                PortalMain.LegalViewController._setBreadcrumbs(agreement);
            }
        );
    },
    
    // populate the agreement content
    _populateAgreement: function(agreement)
    {
        $('#legal-content').html(agreement.body);
        
        PortalHelper.loadingOverlay('.content-col__content', false);
    },
    
    // set the headline according to the current product
    _setHeadline: function(agreement)
    {
        var headline = '';
        
        $('#headline').html(agreement.title);
    },
    
    // set the breadcrumbs according to the current product, and order
    _setBreadcrumbs: function(agreement)
    {
        $('.breadcrumbs .bc-legal').html(agreement.title);
        
        $('.breadcrumbs').removeClass('hidden');
    },
}